<div class="frame-container" [class.fit-content]="fitContent()">
  @if (title()) {
    <div class="frame-header">
      <span class="isg-header-label"
            [title]="showHoverOver() ? title() : null">{{ title() }}</span>
      @if (subtitle()) {
        <span class="frame-subtitle">{{ subtitle() }}</span>
      }
      <ng-content select="[frameAction]"></ng-content>
    </div>
  }
  <div class="frame-content">
    <ng-content></ng-content>
  </div>
</div>
